export function shouldAutoLoadWalletRuntime({
  loadingSession = false,
  runtimeLoaded = false,
  runtimeStatus = "idle",
  session = null,
  privyEmbeddedEnabled = false,
  hasPrivyAuthResume = false,
  hasPrivyOAuthCallback = false
} = {}) {
  if (loadingSession || runtimeLoaded || runtimeStatus !== "idle") {
    return false;
  }

  const sessionWalletAddress = session?.walletAddress || session?.userId || "";
  if (sessionWalletAddress) {
    return true;
  }

  return Boolean(privyEmbeddedEnabled && (hasPrivyAuthResume || hasPrivyOAuthCallback));
}
